export default __webpack_public_path__ + "static/media/mainglass.ad501f78.jpg";